import axios from "axios";
import React, { useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";
import AdminAutoComplete from "../AdminAutoComplete";

const AddSubAdmin = () => {
    document.title = "DirtMap - Add Sub Admin";

    const history = useHistory();
    const [userInput, setUserInput] = useState({
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        company_name: '',
        street_address: '',
        street_address_2: '',
        city: '',
        state: '',
        phone_number: '',
        user_roles: '2',
        user_type: 'sub_admin',
        alert_message_type: '0',
        error_list: [],
    });
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    const [isDisplayed, setIsDisplayed] = useState(false);


    useEffect(() => {
        setInterval(() => {
            setIsDisplayed(true);
        }, 1200);
      }, []);
      
      const setCoodinationValueAddress = (results, ll) => {
        // console.log(results);
         //userInput.street_address = results;
    
         var street1 = "", street2 = "", city = "", state = "", zip = "", country = "";
         for (var i = 0; i < results[0].address_components.length; i++) {
             for (var j = 0; j < results[0].types.length; j++) {
                 if (results[0].address_components[i].types[j] === "street_number" || results[0].address_components[i].types[j] === "sublocality_level_1")
                     street1 = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "route" || results[0].address_components[i].types[j] === "sublocality_level_2")
                     street2 = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "locality")
                     city = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "administrative_area_level_1" || results[0].address_components[i].types[j] === "administrative_area_level_2")
                     state = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "postal_code")
                     zip = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "country")
                     // country = results[0].address_components[i].short_name
                     country = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
             }
         }
 
         // console.log(street1);
         // console.log(street2);
         // console.log(city);
         // console.log(state);
         // console.log(zip);
         // console.log(country);
 
         //  $("input[name=street_address]").val(street1 + ' ' + street2);
         //  $("input[name=city]").val(city);
         //  $("input[name=state]").val(state);
         //  $("input[name=postal_code]").val(zip);
 
         //userInput.street_address_2 = value;

        document.getElementById("__postSearchLocationAdress").value = street1;
        document.getElementById("__postSearchLocationAdress2").value = street2;
        document.getElementById("__postSearchLocationCity").value = city;
        document.getElementById("__postSearchLocationState").value = state;
        document.getElementById("__postLatitude").value = ll.lat;
        document.getElementById("__postLongitude").value = ll.lng;
 
         userInput.street_address = street1;
         userInput.street_address_2 = street2;
         userInput.city = city;
         userInput.state = state;
         userInput.latitude = ll.lat;
         userInput.longitude = ll.lng;

     
         //street_address_2
 
     }
 

    const handleInput = (e) => {
        e.persist();
        setUserInput({ ...userInput, [e.target.name]: e.target.value });
    }

    const submitUser = (e) => {
        e.preventDefault();
        const data = {
            email: userInput.email,
            password: userInput.password,
            first_name: userInput.first_name,
            last_name: userInput.last_name,
            user_name: userInput.user_name,
            company_name: userInput.company_name,
            street_address: userInput.street_address,
            street_address_2: userInput.street_address_2,
            city: userInput.city,
            state: userInput.state,
            user_type: userInput.user_type,
            phone_number: userInput.phone_number,
            alert_message_type: userInput.alert_message_type,
        }
        showLoader();
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post(`/api/user/register`, data).then(res => {
                if (res.data.result) {
                    hideLoader();
                    swal("success", "User Created Sucessfully Done", "success");
                    history.push('/admin/sub-admin/index');
                }
                else {
                    hideLoader();
                    setUserInput({ ...userInput, error_list: res.data.errors });
                }
            });
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h4 className="card-title mb-0">Create Sub Admin</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={submitUser}>
                    <input type="hidden" name="user_roles" onChange={handleInput} value={userInput.user_roles}  />
                    <input type="hidden" name="user_type" onChange={handleInput} value={userInput.user_type}  />
                    <input type="hidden" name="alert_message_type" onChange={handleInput} value={userInput.alert_message_type}  />
                    <input type="hidden" id="__postSearchLocationAdress" name="street_address" onChange={handleInput} value={userInput.street_address} />
                    <input type="hidden" id="__postLatitude" name="latitude" onChange={handleInput} value={userInput.latitude} />
                    <input type="hidden" id="__postLongitude" name="longitude" onChange={handleInput} value={userInput.longitude} />
    
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">First Name</label>
                                    <input type="text" name="first_name" onChange={handleInput} value={userInput.first_name} className="form-control" placeholder="Enter First Name" />
                                    <span className="validate-error-message">{userInput.error_list.first_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Last Name</label>
                                    <input type="text" name="last_name" onChange={handleInput} value={userInput.last_name} className="form-control" placeholder="Enter Last Name" />
                                    <span className="validate-error-message">{userInput.error_list.last_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="userName">User Name</label>
                                    <input type="text" name="user_name" onChange={handleInput} value={userInput.user_name} className="form-control" placeholder="Enter User Name" />
                                    <span className="validate-error-message">{userInput.error_list.user_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" name="email" onChange={handleInput} value={userInput.email} className="form-control" placeholder="Enter Email" />
                                    <span className="validate-error-message">{userInput.error_list.email}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="password">Password</label>
                                    <input type="password" name="password" onChange={handleInput} value={userInput.password} className="form-control" placeholder="Enter Password" />
                                    <span className="validate-error-message">{userInput.error_list.password}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm Password</label>
                                    <input type="password" name="confirm_password" onChange={handleInput} value={userInput.confirm_password} className="form-control" placeholder="Enter Confirm Password" />
                                    <span className="validate-error-message">{userInput.error_list.confirm_password}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="companyName">Company Name</label>
                                    <input type="text" name="company_name" onChange={handleInput} value={userInput.company_name} className="form-control" placeholder="Enter Company Name" />
                                    <span className="validate-error-message">{userInput.error_list.company_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="streetAddress">Street Address</label>
                                    {/* <input type="text" name="street_address" onChange={handleInput} value={userInput.street_address} className="form-control" placeholder="Enter Street Address" /> */}
                                    {isDisplayed &&
                                        <AdminAutoComplete
                                            apiKey={'AIzaSyCv7m-2LTrrKnu1P38xKNBvvFJXoQGAnGg'}
                                            setCoodinationValueAddress={setCoodinationValueAddress}
                                        />
                                    }
                                    <span className="validate-error-message">{userInput.error_list.street_address}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="streetAddress2">Street Address 2</label>
                                    <input type="text" id="__postSearchLocationAdress2" name="street_address_2" onChange={handleInput} value={userInput.street_address_2} className="form-control" placeholder="Enter Street Address 2" />
                                    
                                    
                                    <span className="validate-error-message">{userInput.error_list.street_address_2}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="City">City</label>
                                    <input type="text" id="__postSearchLocationCity" name="city" onChange={handleInput} value={userInput.city} className="form-control" placeholder="Enter City" />
                                 
                                    
                                    <span className="validate-error-message">{userInput.error_list.city}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="State">State</label>
                                    <input type="text" id="__postSearchLocationState" name="state" onChange={handleInput} value={userInput.state} className="form-control" placeholder="Enter State" />
                                   
                                    
                                    <span className="validate-error-message">{userInput.error_list.state}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="phoneNumber">Phone Number</label>
                                    <input type="text" name="phone_number" onChange={handleInput} value={userInput.phone_number} className="form-control" placeholder="Enter Phone Number" />
                                    <span className="validate-error-message">{userInput.error_list.phone_number}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <button type="submit" className="btn btn-primary">Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {loader}
        </div>
    );
}
export default AddSubAdmin;